import { Component, OnInit } from '@angular/core';
import { NavParams, PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-video-player',
  templateUrl: './video-player.component.html',
  styleUrls: ['./video-player.component.scss'],
})
export class VideoPlayerComponent implements OnInit {
  videotitle:string;
  video:string;
  constructor(
    public popoverController: PopoverController,
    public params: NavParams
    ) { 

    
    }

  ngOnInit() {
    if (this.params.get('type') == "overview")
    {
      this.videotitle = "App Overview";
      this.video="overview";
    }
    if (this.params.get('type') == "basic")
    {
      this.videotitle = "Basic";
      this.video="basic";
    }
    if (this.params.get('type') == "advanced")
    {
      this.videotitle = "Advanced";
      this.video="advanced";
    }
    if (this.params.get('type') == "submissions")
    {
      this.videotitle = "Submissions";
      this.video="submissions";
    }
    if (this.params.get('type') == "wardrounds")
    {
      this.videotitle = "Ward Rounds";
      this.video="wardrounds";
    }
    if (this.params.get('type') == "mbs")
    {
      this.videotitle = "MBS";
      this.video="mbs";
    }
    if (this.params.get('type') == "update")
    {
      this.videotitle = "Update Details";
      this.video="update";
    }
    if (this.params.get('type') == "contact")
    {
      this.videotitle = "Contact Us";
      this.video="contact";
    }
  }

  onModalDismiss() {
    this.popoverController.dismiss(false);
  }

}
